<template>
  <footer class="custom-footer">
    <div class="footer-content">
      <p>
        {{ year }} © JBI
        <template>
          | Version: {{ majorVersion }}.{{ minorVersion }}, Build: {{ patchVersion }}
        </template>
      </p>
    </div>
  </footer>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AppFooter extends Vue {
  @Prop({ required: true })
  year!: number;

  @Prop({ required: true })
  majorVersion!: number;

  @Prop({ required: true })
  minorVersion!: number;

  @Prop({ required: true })
  patchVersion!: number;
}
</script>

<style lang="scss" scoped>
.custom-footer {
  display: grid;
  place-items: center;
  background-color: white;
  padding-bottom: 2rem;
}

.footer-content {
  color: #71797c;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}
</style> 